export enum LegacyAttributeListGap {
  Default = 'default',
  Wide = 'wide',
}

export const LegacyAttributeListVariant = {
  Light: 'light',
  Prominent: 'prominent',
} as const;

export type LegacyAttributeListVariantType =
  (typeof LegacyAttributeListVariant)[keyof typeof LegacyAttributeListVariant];

export const LegacyAttributeListSurface = {
  Base: 'base',
  Raised: 'raised',
} as const;

export type LegacyAttributeListSurfaceType =
  (typeof LegacyAttributeListSurface)[keyof typeof LegacyAttributeListSurface];

export type LegacyAttributeListProps = {
  /** Root `data-testid` for tests/e2e. */
  testId?: string;
  withDividers?: boolean;
  expand?: boolean;
  columns?: 1 | 2;
  gap?: LegacyAttributeListGap;
  variant?: LegacyAttributeListVariantType;
  surface?: LegacyAttributeListSurfaceType;
};

export type LegacyAttributeListSlots = {
  default?: () => unknown;
  action?: () => unknown;
};
